import { setAuthCookies } from 'api/pages/api'
import { isLocalEnvironment } from 'config'
import { setStorageItem } from 'utils/localStorage'

const SetToken = props => {
  const { location } = props
  const urlParams = new URLSearchParams(location.search)
  const token = urlParams.get('token')
  const redirectURL = urlParams.get('redirect_url')
  const loggedAs = urlParams.get('logged_as_user')
  const permissionType = urlParams.get('permission_type')
  if (isLocalEnvironment()) {
    setStorageItem('tokenAccounts', token)
  }
  setStorageItem('loggedAs', loggedAs)
  setAuthCookies(token, permissionType).then(() => {
    if (window.parent) {
      window.parent.postMessage('token-set', '*')
    }
    if (redirectURL) {
      window.location.href = redirectURL
    }
  })
  return null
}

export default SetToken
